<!--
 * @Description: 直播限制问卷
 * @Date: 2021-02-03 17:57:37
-->
<template>
  <div>
    <div v-if="!isDesktop" style="padding-bottom: 1rem">
      <img :src="checkInfo.image" alt width="100%" />
      <van-form @submit="confirm" label-width="60px">
        <ul>
          <li
            v-for="(item, index) in question"
            :key="index"
            class="custom-field"
          >
            <van-field
              v-if="![3, 4, 5].includes(item.type)"
              v-model.trim="item.value"
              class="itemBox"
              :maxlength="30"
              :label="item.name + ':'"
              :required="item.request == 1"
              :rules="
                item.request == 1 || item.type == 2
                  ? [
                      item.request == 1 && item.type == 2
                        ? { required: true, message: '请输入手机号' }
                        : null,
                      ...rules[parseInt(item.type)]
                    ].filter(i => i)
                  : []
              "
            ></van-field>
            <van-field
              v-if="item.type == 3"
              v-model="item._value"
              readonly
              class="itemBox"
              right-icon="arrow"
              @click="toHospital(item)"
              :label="item.name + ':'"
              :required="item.request == 1"
              :rules="item.request == 1 ? rules[3] : []"
            ></van-field>
            <van-field
              v-if="item.type == 4"
              v-model="item._value"
              readonly
              class="itemBox"
              right-icon="arrow"
              @click="showToast('dep', item)"
              :label="item.name + ':'"
              :required="item.request == 1"
              :rules="item.request == 1 ? rules[4] : []"
            ></van-field>
            <van-field
              v-if="item.type == 5"
              v-model="item._value"
              readonly
              class="itemBox"
              right-icon="arrow"
              @click="showToast('duty', item)"
              :label="item.name + ':'"
              :required="item.request == 1"
              :rules="item.request == 1 ? rules[5] : []"
            ></van-field>
          </li>
        </ul>
        <div style="margin-top: 16px">
          <van-button class="btn" block type="info" native-type="submit">
            提交
          </van-button>
        </div>
      </van-form>
      <van-popup v-model="show" position="bottom" class="showPop">
        <van-picker
          v-if="type === 'dep'"
          show-toolbar
          title="请选择科室"
          :columns="departmentList"
          @cancel="show = false"
          value-key="name"
          @confirm="confirmDep"
        />
        <van-picker
          v-else
          value-key="name"
          show-toolbar
          title="请选择职称"
          :columns="dutyList"
          @cancel="show = false"
          @confirm="confirmDut"
        />
      </van-popup>
      <div class="fixed" v-if="showHospital">
        <chooseHospital
          :isComponent="true"
          @change="confirmHospital"
          @cancel="showHospital = false"
        ></chooseHospital>
      </div>
    </div>
    <div v-if="isDesktop">
      <PcContainer :needTop="false">
        <template slot="center">
          <div class="container-center-center">
            <h3 style="line-height: 80px; font-size: 24px">观看限制</h3>
            <img :src="checkInfo.image" alt width="100%" />
            <el-form
              style="text-align: left; margin: 25px 0 0 16px"
              ref="ruleForm"
              label-width="90px"
              label-position="right"
              inline
              :model="ruleForm"
              :rules="rules"
            >
              <ul>
                <li
                  v-for="(item, index) in ruleForm.PcQuestion"
                  :key="index"
                  class="custom-field-pc"
                >
                  <el-form-item
                    :prop="`PcQuestion[${index}].value`"
                    :maxlength="30"
                    class="itemBox"
                    :label="item.name + ':'"
                    :required="item.request == 1"
                    :rules="
                      item.request == 1 || item.type == 2
                        ? [
                            item.request == 1 && item.type == 2
                              ? { required: true, message: '请输入手机号' }
                              : null,
                            ...rules[parseInt(item.type)]
                          ].filter(i => i)
                        : []
                    "
                    v-if="![3, 4, 5].includes(item.type)"
                  >
                    <el-input v-model="item.value"></el-input>
                  </el-form-item>
                  <!-- <el-form-item
                    :prop="`PcQuestion[${index}].value`"
                    :maxlength="30"
                    class="itemBox"
                    :label="item.name + ':'"
                    :required="item.request == 1"
                    :rules="
                      item.request == 1 || item.type == 2
                        ? rules[parseInt(item.type)]
                        : []
                    "
                    v-if="item.type == 2"
                  >
                    <el-input v-model="item.value"></el-input>
                  </el-form-item> -->
                  <el-form-item
                    v-if="item.type == 3"
                    :prop="`PcQuestion[${index}].value`"
                    class="itemBox"
                    :label="item.name + ':'"
                    :required="item.request == 1"
                    :rules="item.request == 1 ? rules[3] : []"
                  >
                    <el-cascader
                      ref="city"
                      v-model="item.value"
                      @change="val => handleChange(val, index)"
                      :props="props"
                      filterable
                      clearable
                    ></el-cascader>
                  </el-form-item>
                  <el-form-item
                    v-if="item.type == 4"
                    :prop="`PcQuestion[${index}]._value`"
                    class="itemBox"
                    :label="item.name + ':'"
                    :required="item.request == 1"
                    :rules="item.request == 1 ? rules[4] : []"
                  >
                    <el-select
                      @change="val => handchange1(val, index)"
                      v-model="item._value"
                    >
                      <el-option-group
                        v-for="option in departmentList"
                        :key="option.id"
                        :label="option.name"
                        clearable
                      >
                        <el-option
                          v-for="kitem in option.children"
                          :key="kitem.id"
                          :label="kitem.name"
                          :value="`${kitem.id},${kitem.name}`"
                        ></el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="item.type == 5"
                    class="itemBox"
                    :prop="`PcQuestion[${index}]._value`"
                    :label="item.name + ':'"
                    :required="item.request == 1"
                    :rules="item.request == 1 ? rules[5] : []"
                  >
                    <el-select
                      @change="val => handchange(val, index)"
                      v-model="item._value"
                    >
                      <el-option
                        v-for="yitem in dutyList"
                        :key="yitem.id"
                        :label="yitem.name"
                        :value="`${yitem.id},${yitem.name}`"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </li>
              </ul>
              <div style="text-align: center">
                <el-button
                  type="primary"
                  size="large"
                  style="height: 38px; width: 407px"
                  color="#3667EC"
                  @click="pcsubmit"
                >
                  提交
                </el-button>
              </div>
            </el-form>
          </div>
        </template>
      </PcContainer>
    </div>
  </div>
</template>

<script>
import { customerUser, dicBase, fileUpload, updateHeadPhoto } from '@/api/ajax';
import chooseHospital from '../../perfect/chooseHospital';
import { saveViewingCheckInfoAnswer } from '@/api/course';
import { mapMutations, mapState } from 'vuex';
import PcContainer from '@/components/pclogin/pcContainer';
import { setStorage, syncUserInfo } from '@/utils/storage';

export default {
  name: 'LivingSurvey',
  data() {
    return {
      _item: {},
      ruleForm: {
        PcQuestion: []
      },
      checkPhone: (rule, value, callback) => {
        // 无内容不校验
        if (value.length === 0) {
          callback();
          return true;
        }
        let reg = /^1[345789]\d{9}$/;
        if (!reg.test(value)) {
          callback(new Error('请输入11位手机号'));
        } else {
          callback();
        }
      },
      props: {
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level } = node;
          const nodes = [];
          // let type = level == 0 ? '1' : node.value;
          if (level == 0) {
            dicBase.provinceList().then(res => {
              const provinceList = res.data.data;
              provinceList.map(item => {
                let obj = {
                  value: item.id,
                  label: item.areaName,
                  leaf: node.level >= 3
                };
                nodes.push(obj);
              });
              resolve(nodes);
            });
          } else if (level == 1) {
            console.log(node);
            dicBase
              .cityAreList({
                parentId: node.value
              })
              .then(res => {
                const cityList = res.data.data;
                cityList.map(item => {
                  let obj = {
                    value: item.id,
                    label: item.areaName,
                    leaf: node.level >= 3
                  };
                  nodes.push(obj);
                });
                resolve(nodes);
              });
          } else if (level == 2) {
            dicBase
              .cityAreList({
                parentId: node.value
              })
              .then(res => {
                const cityList = res.data.data;
                cityList.map(item => {
                  let obj = {
                    value: item.id,
                    label: item.areaName,
                    leaf: node.level >= 3
                  };
                  nodes.push(obj);
                });
                resolve(nodes);
              });
          } else if (level == 3) {
            dicBase
              .areaHospitalList({
                areaId: node.value
              })
              .then(res => {
                const hostptol = res.data.data;
                hostptol.map(item => {
                  let obj = {
                    value: item.id,
                    label: item.fullName,
                    leaf: node.level >= 3
                  };
                  nodes.push(obj);
                });
                console.log(nodes);
                resolve(nodes);
              });
          }
        }
      },
      show: false,
      showHospital: false,
      type: 'dep',
      showcell: false,
      dutyList: [],
      departmentList: [],
      question: []
    };
  },
  components: { chooseHospital, PcContainer },
  watch: {
    checkInfo: {
      handler(v) {
        if (v.quesqionJson) {
          try {
            let question = JSON.parse(v.quesqionJson);
            question.forEach(item => {
              item.value = '';
            });
            this.question = question;
            this.ruleForm.PcQuestion = question;
          } catch (e) {
            console.log(e);
          }
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapState({
      isDesktop: state => state.living.isDesktop
    }),
    rules() {
      return {
        1: [{ required: true, message: '请输入昵称' }],
        2: !this.isDesktop
          ? [
              {
                validator: v => {
                  console.log(v);
                  if (v.length === 0) {
                    return true;
                  }
                  return /^1[0-9]{10}$/.test(`${v}`);
                },
                message: '请输入正确的手机号'
              }
            ]
          : [{ validator: this.checkPhone }],
        3: [{ required: true, message: '请选择医院', trigger: 'change' }],
        4: [{ required: true, message: '请选择科室', trigger: 'change' }],
        5: [{ required: true, message: '请选择职称' }],
        6: [{ required: true, message: '请输入' }]
      };
    },
    checkInfo() {
      return this.$store.state.living.checkInfo;
    },
    hospitalInfo() {
      return this.$store.state.register.hospitalInfo || {};
    }
  },
  methods: {
    ...mapMutations(['SET_PERFECT']),
    handleChange(value, index) {
      const data = this.$refs['city'][0].getCheckedNodes()[0];
      console.log(value, data);
      if (data) {
        this.$set(this.ruleForm.PcQuestion[index], 'value', data.value);
        this.$set(this.ruleForm.PcQuestion[index], '_value', data.label);
      } else {
        // data undefined 表示清空
        this.$set(this.ruleForm.PcQuestion[index], 'value', '');
        this.$set(this.ruleForm.PcQuestion[index], '_value', '');
      }
    },
    handchange(val, index) {
      let [value, label] = val.split(',');
      this.ruleForm.PcQuestion[index].value = value;
      this.ruleForm.PcQuestion[index]._value = label;
    },
    handchange1(val, index) {
      let [value, label] = val.split(',');
      this.ruleForm.PcQuestion[index].value = value;
      this.ruleForm.PcQuestion[index]._value = label;
    },
    toHospital(item) {
      this._item = item;
      this.showHospital = true;
    },
    confirmHospital(item) {
      const { id, fullName } = item;
      this._item.value = id;
      this._item._value = fullName;
      this.showHospital = false;
    },
    confirmDep(item, id) {
      this._item.value = this.departmentList[id[0]].children[id[1]].id;
      this._item._value = item.join('-');
      this.show = false;
    },
    confirmDut(item) {
      const { id, name } = item;
      this._item.value = id;
      this._item._value = name;
      this.show = false;
    },
    showToast(type, item) {
      this._item = item;
      this.type = type;
      this.show = true;
    },
    pcsubmit() {
      this.$refs['ruleForm'].validate(async valid => {
        if (valid) {
          const { data } = await saveViewingCheckInfoAnswer({
            courseId: this.checkInfo.courseId,
            channelId: this.checkInfo.channelId,
            authId: this.checkInfo.id,
            answer: JSON.stringify(this.ruleForm.PcQuestion)
          });
          // 设置是否提交过问卷 （用于未登录用户）
          setStorage('hideLiveSurvey', this.checkInfo.courseId);
          // 有用户信息的则同步
          if (this.$store.state.user.info.id) {
            syncUserInfo();
          }
          this.$store.dispatch('living/init');
          this.$toast('提交成功');
        }
      });
    },
    async confirm() {
      try {
        const { data } = await saveViewingCheckInfoAnswer({
          courseId: this.checkInfo.courseId,
          channelId: this.checkInfo.channelId,
          authId: this.checkInfo.id,
          answer: JSON.stringify(this.question)
        });
        // 设置是否提交过问卷 （用于未登录用户）
        setStorage('hideLiveSurvey', this.checkInfo.courseId);
        // 有用户信息的则同步
        if (this.$store.state.user.info.id) {
          syncUserInfo();
        }
        this.$store.dispatch('living/init');
        this.$toast('提交成功');
      } catch (error) {}
    }
  },
  created() {
    dicBase.departmentList().then(res => {
      this.departmentList = res.data.data;
    });
    dicBase.dutyList().then(res => {
      this.dutyList = res.data.data;
    });
  },
  beforeDestroy() {}
};
</script>

<style lang="scss">
.el-form-item__content {
  width: 335px;
}
.el-input--suffix {
  width: 335px;
}
.custom-field {
  .van-cell {
    overflow: inherit;
  }
  .van-field--error .van-field__control {
    &::-webkit-input-placeholder {
      color: #969799;
    }
  }
  .van-field__control {
    color: #333;
  }
  .van-field__value {
    position: relative;
    .van-field__control {
      font-size: 0.38rem;
    }
    .van-field__error-message {
      position: absolute;
      left: 0;
      line-height: 2.5;
    }
  }
  &-pc {
    .van-field__value {
      position: relative;
      .van-field__control {
        font-size: 14px;
      }
      .van-field__error-message {
        position: absolute;
        left: 0;
        bottom: -30px;
      }
    }
  }
}
</style>
<style scoped lang="scss">
.van-form {
  width: 7.56rem;
  margin: 0 auto;
  margin-top: 0.55rem;
  ul {
    li {
      border: 1px solid rgba($color: #a1a1a1, $alpha: 0.26);
      & + li {
        margin-top: 0.57rem;
      }
      & > div {
        padding: 5px 16px;
      }
    }
  }
  .btn {
    width: 100%;
    height: 1.12rem;
    background: linear-gradient(182deg, #5cc4ff, #004eee);
    border-radius: 0.2rem;
    border: none;
  }
}
.fixed {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background-color: #fff;
}
.pc-hospital {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba($color: #000, $alpha: 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  & > div {
    width: 375px;
    height: 667px;
    position: relative;
    overflow: hidden;
    border-radius: 5px;
  }
  :v-deep {
    .van-field__control {
      font-size: 16px;
    }
  }
}
</style>
